import * as buffer from "buffer";
import apiService from "./apiService";
window.Buffer = buffer.Buffer;
const crypto = require("crypto-browserify");

const encryptData = (plainData) => {
  const key = process.env.REACT_APP_KEY;
  const iv = process.env.REACT_APP_IV;

  const cipher = crypto.createCipheriv("aes-256-gcm", key, iv);
  const encryptedPayload = Buffer.concat([
    cipher.update(JSON.stringify(plainData), "utf8"),
    cipher.final(),
  ]);

  const tag = cipher.getAuthTag();
  const encryptedData = Buffer.concat([encryptedPayload, tag]);

  const encstring = btoa(
    new Uint8Array(encryptedData)
      .reduce((data, byte) => data + String.fromCharCode(byte), '')
  );
  return encstring;
};

const decryptData = (encData) => {
  const key = process.env.REACT_APP_KEY;
  const iv = process.env.REACT_APP_IV;

  try {
    const decipher = crypto.createDecipheriv("aes-256-gcm", key, iv);
    const decodedCiphertext = Buffer.from(
      encData?.toString(),
      "base64"
    ).toString("hex");
    const taga = decodedCiphertext.slice(-32);
    const encryptedText = decodedCiphertext.slice(0, -32);
    decipher.setAuthTag(Buffer.from(taga, "hex"));

    let decryptedText = decipher.update(encryptedText, "hex", "utf8");
    decryptedText += decipher.final("utf8");
    return decryptedText;
  } catch (error) {
    return { error: "invalid_data" };
  }

  return { error: "UEX" };
};

const validateADID = async (userid = null) => {
  if (!userid) {
    return {
      error: {
        message: "Please enter your UserID.",
      },
    };
  }

  const apiData = {
    userid: userid,
  };

  const response = await apiService.fetchData(apiData, "getloginurl");

  if (response?.data?.tokennumber) {
    sessionStorage.setItem("userDetail", authService.enc(response.data));
  }

  return response;
};

const handleLogin = async (code) => {
  const userDetails =
    sessionStorage.getItem("userDetail") &&
    JSON.parse(authService.dec(sessionStorage.getItem("userDetail")));

  const apiData = {
    code: code,
    tokennumber: userDetails?.tokennumber,
  };

  const response = await apiService.fetchData(apiData, "logincallback");

  return response;
};

const getAccessToken=()=>{
  const userDetail =
  sessionStorage.getItem("userDetail") &&
  JSON.parse(authService.dec(sessionStorage.getItem("userDetail")));
  if (userDetail?.userinfo?.sessioninfo) {
    return encryptData({
      "sessionkey": userDetail?.userinfo?.sessioninfo,
      "userid": userDetail?.userinfo?.userid
  })
  }
}

const authService = {
  enc: encryptData,
  dec: decryptData,
  getAccessToken:getAccessToken,
  validateADID: (userid) => validateADID(userid),
  handleLogin: (code) => handleLogin(code),
};

export default authService;
